<template>
  <div class="mt-3">
    <div class="d-flex">
      <v-sheet class="ref-material-tile mr-6" rounded elevation="0" @click="openPanel(1)">
        <v-icon class="mr-2">mdi-folder</v-icon>
        <span class="font-weight-medium">{{ $t('references') }}</span>
      </v-sheet>

      <v-sheet class="ref-material-tile" rounded elevation="0" @click="openPanel(2)">
        <v-icon class="mr-2">mdi-folder</v-icon>
        <span class="font-weight-medium">{{ $t('finals') }}</span>
      </v-sheet>
    </div>
  </div>
</template>

<script>
  export default {
    name: "JobFilesField",

    props: {
      field: {
        type: Object,
        default: () => ({})
      }
    },

    methods: {
      openPanel(type) {
        const damStartNodeId = type === 1
          ? this.field.referencesNodeId
          : this.field.finalsNodeId

        this.$emit('openFilesPanel', { type, damStartNodeId })
      }
    }
  }
</script>

<style scoped>
  .ref-material-tile {
    display: inline-flex;
    align-items: center;
    padding: 14px 18px;
    background: #eef2f7;
    cursor: pointer;
    border-radius: 10px;
    border: 1px solid #e5e9f2;
    transition: background 0.2s ease, box-shadow 0.2s ease;
  }

  .ref-material-tile.disabled {
    opacity: .6;
    cursor: not-allowed;
  }

  .ref-material-tile:hover {
    background: #e9eff8;
  }
</style>
